export default __webpack_public_path__ + "static/media/background.c1fdeb6d.jpg";